//----- Component --------------------------------------------------------/
// Developer :  Daiana Curcio
// Creation Date : 02/06/2025
// Version : 1
// Description : Para asignar los clientes
//
//------Changes --------------------------------------------------------------------- -------------//
// Change Date :
// Change by :
// Change description:
//
// Change Date :
// Change by :
// Change description:
//========================================================================/
import {
  Dialog,
  Box,
  TextField,
  Grid,
  IconButton,
  Typography,
  Button,
  DialogContent,
  Autocomplete,
  DialogActions,
} from "@mui/material";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import React, { useState, useEffect } from "react";
import { grey } from "@mui/material/colors";
import { UrlApi } from "../../../services/apirest";
import Notify from "../../Notify";
import { logEventos } from "../../../services/services";
import AttachFileIcon from "@mui/icons-material/AttachFile"; //ADJUNTAR
import FileUploadReguladores from "./FileUploadReguladores";

export default function ElegirCliente(props) {
  const { open, setOpen, uuid, newUuid } = props;
  const [notificacion, setNotificacion] = useState(false); //define si se muestra o no una notificación (snackbar)
  const [openSnack, setOpenSnack] = React.useState(false); //abre y cierra snack
  const [mensaje, setMensaje] = useState(""); //mensaje q mostrará la notif
  const [error, setError] = useState(null);
  const [clientes, setClientes] = useState([]);
  const [uniqueCliente, setUniqueCliente] = useState("");
  const [disbtn, setdisBtn] = useState(false);
  const [datosFormulario, setdatosFormulario] = useState({
    id_cliente: null,
    estado_tab: 326,
  });

  const [activeTab, setActiveTab] = useState(props.activeTab);
  const [datosRegulador, setDatosRegulador] = useState(props.datos);
  const [openCloseAdj, setOpenCloseAdj] = useState(false); //ADJUNTAR COMPROBANTE

  const handleOpenCloseAdj = (value) => {
    setOpenCloseAdj(value);
  };

  //----------------- BLOQUEO DEL BOTON GUARDAR PARA ADJUNTAR ----------------------//
  const [archivoCargado, setArchivoCargado] = useState(false);
  // Función para manejar la carga del archivo
  const manejarArchivoCargado = (file) => {
    // determinar si el archivo se cargó correctamente
    if (file) {
      setArchivoCargado(true);
    } else {
      setArchivoCargado(false);
    }
  };
  // Función para manejar la eliminación del archivo
  const manejarArchivoEliminado = () => {
    setArchivoCargado(false); // Desmarcar como cargado cuando se elimina un archivo
  };

  useEffect(() => {
    if (props?.datos?.id_instalador) {
      fetch(
        UrlApi + `/reclamos/reguladoresConTecnicos/${props.datos.id_instalador}`
      )
        .then((res) => res.json())
        .then(setClientes);
    }
  }, [props.datos]);

  // console.log("CLIENTES",clientes);

  const almacenar = (e) => {
    setdatosFormulario({
      ...datosFormulario,
      [e.target.name]: e.target.value ? e.target.value : " ",
    });
  };

  const style = {
    backgroundColor: "#ffffff",
    width: "100%",
  };
  //console.log("UNIQUECLIENTE",uniqueCliente);

  const handleGuardarCliente = async (e) => {
    logEventos(
      "Guardar cliente ",
      "Administracion Reguladores",
      "Se guardó el cliente",
      localStorage.getItem("user")
    );
    e.preventDefault();
    setDeshabilitado(true);

    try {
      let response = await fetch(
        UrlApi + "/reguladores_abm/" + props.datos.id_regulador,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id_cliente: uniqueCliente.id_cliente,
            estado_tab: 326,
          }),
        }
      );

      if (!response.ok) {
        const error = await response.json();
        setError(error);
        alert("Inconvenientes con la API. No se pudo guardar.");
        return;
      }

      // Esperá la respuesta aunque sea vacía
      try {
        await response.json();
      } catch (_) {
        // Ignorá si no es JSON (por ejemplo, 204)
      }

      // Notificación y cierre
      setNotificacion(true);
      setOpenSnack(true);
      setMensaje("Guardado");
      props.actualizar();
      handleClose();
    } catch (error) {
      alert("Error: " + error);
    }
  };

  const handleClose = () => {
    props.tabla(true);
    setOpen(false); // Cierra el diálogo notificando al padre
  };

  //console.log("INSTALADOR SELECCIONADO",uniqueCliente,"telefono instalador",uniqueCliente.celular_user);
  const [deshabilitado, setDeshabilitado] = useState(false);

  useEffect(() => {
    if (Object.keys(uniqueCliente).length === 0) {
      setDeshabilitado(true);
    } else {
      setDeshabilitado(false);
    }
  }, [uniqueCliente]);

  return (
    <div>
      <Dialog open={open} fullWidth>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container backgroundColor="#1F618D" p={1.5}>
            <Grid item xs={2}>
              <IconButton onClick={() => setOpen(false)} sx={{ color: "#fff" }}>
                <ArrowBackIcon />
              </IconButton>
            </Grid>

            <Grid
              item
              xs={8}
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
            >
              <Typography variant="h5" color="#ffffff">
                Asignar Cliente
              </Typography>
            </Grid>
          </Grid>
        </Box>
        <DialogContent>
          <Box
            backgroundColor="#F4F6F6"
            mt={2}
            mb={2}
            ml={3}
            p={3}
            border={0.5}
            borderColor={"#ABB2B9"}
            borderRadius={4}
          >
            <Grid container spacing={1} direction={{ xs: "column", sm: "row" }}>
              <Grid item xs={12}>
                <Autocomplete
                  style={style}
                  noOptionsText={"Cliente INEXISTENTE"}
                  options={clientes || []}
                  autoHighlight
                  disableClearable
                  getOptionLabel={(clientes) => clientes.razon_social}
                  onChange={(event, value) => setUniqueCliente(value)}
                  renderOption={(props, option) => (
                    <Box
                      component="li"
                      key={`${option.sisven_id} - ${option.razon_social}`}
                      sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                      {...props}
                    >
                      {`${option.sisven_id} - ${option.razon_social}`}
                    </Box>
                  )}
                  renderInput={(params) => (
                    <TextField
                      fullWidth={true}
                      placeholder="Tipee para buscar un cliente.."
                      {...params}
                      variant="outlined"
                      label="Clientes "
                      inputProps={{
                        ...params.inputProps,
                      }}
                    />
                  )}
                />
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions>
          <Grid container direction="row" alignItems="flex-end" mt={0}>
            <Grid item xs={12} container justifyContent="center">
              <Button
                variant="outlined"
                color="info"
                size="medium"
                onClick={() => handleOpenCloseAdj(true)}
                startIcon={<AttachFileIcon color="action" />}
              >
                ADJUNTAR DOCUMENTACIÓN
              </Button>
            </Grid>
            <Grid item xs={12} container justifyContent="flex-end" mt={1}>
              <Button
                disabled={deshabilitado}
                variant="contained"
                type="submit"
                color="success"
                size="small"
                onClick={handleGuardarCliente}
              >
                Asignar Cliente
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
        {notificacion ? (
          <Notify
            mensaje={mensaje}
            open={openSnack}
            color={"#D4EFDF"}
            severity={"success"}
            handleClose={handleClose}
            error={error}
          />
        ) : null}
        {openCloseAdj ? ( // ADJUNTAR COMPROBANTES
          <FileUploadReguladores
            fileId={newUuid}
            openclose={true}
            mostrar={true}
            onClose={() => handleOpenCloseAdj(false)} // cierre
            onFileUpload={manejarArchivoCargado} // estado de carga de archivo
            onDeleteFile={manejarArchivoEliminado} // estado de eliminacion de archivo
          />
        ) : null}
      </Dialog>
    </div>
  );
}
